import React from "react";
import Goo from "../../ui-library/Goo/Goo";
import logo from "../../../assets/logo.png";

const FullPageLoading = () => {
  return (
    <div
      data-testid="full-page-loading"
      style={{
        width: "100vw",
        overflow: "hidden",
        height: "100vh",
        marginTop: "-75px",
      }}
      className="d-flex flex-column justify-content-center align-items-center w-100"
      id="full-page-loading"
    >
      <div style={{ zIndex: "100" }}>
        <img src={logo} alt="Logo" style={{ width: "25vw" }} />
      </div>
      <div style={{ zIndex: "100" }}>
        <span className="text-secondary mr-2">Loading Rarify ...</span>
        <div className="spinner-border" role="status"></div>
      </div>
      <Goo
        style={{ zIndex: "50" }}
        center={[window.innerWidth / 2, window.innerHeight / 3]}
      />
    </div>
  );
};

export default FullPageLoading;
